import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class XsrfInterceptor implements HttpInterceptor {

  constructor(private cookieService: CookieService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    const xsrfToken = this.cookieService.get('XSRF-TOKEN-REQUEST');

    let modifiedReq = req;
    // Check whether the request is to an API route
    if (req.url.includes('/api')) {
      // If we have an XSRF token, set it in the request headers

      if (xsrfToken) {
        modifiedReq = req.clone({
          withCredentials: true, // Include credentials in the request
          headers: req.headers.set('X-XSRF-TOKEN', xsrfToken)
        });
      }
    }

    return next.handle(modifiedReq); // Pass the request to the next handler
  }
}
